import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Main } from 'Containers/';
import { AERIES_PREVIEW_FORM_NAME } from 'Common/FormEnum';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { AeriesFieldEnum } from 'Common/Constants/SISIntegration';
import { submitForm } from 'State/forms/actions';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';

import { AeriesPreview } from './AeriesPreview';
import * as actions from '../../state/actions';
import * as selectors from '../../state/selectors';

class AeriesPreviewStepContainer extends Component {
  static stepInfo = {
    icon: 'info',
    title: 'Preview',
    description: 'Confirm the data is mapped correctly.',
  };

  state = {
    PreviewedStudentId: null,
    PreviewedStudentSchoolCode: null,
    previewComplete: false,
  };

  componentDidMount() {
    const { getConfiguration } = this.props;
    getConfiguration();
  }

  mainProps = () => {
    const {
      loading,
      goToNextStep,
      goToPreviousStep,
      stepCompleted,
      importStudent,
      setYesNoDialogProps,
    } = this.props;

    const {
      previewedStudentId,
      previewedStudentSchoolCode,
      previewComplete,
    } = this.state;

    const mainPreviewProps = {
      toolbox: {
        formName: AERIES_PREVIEW_FORM_NAME,
        saveButtonProps: {
          content: 'Preview',
          loading: loading,
          disabled: loading,
        },
        backButtonProps: {
          shown: true,
          disabled: loading,
          callback: goToPreviousStep,
        },
        rightButtons: [
          {
            content: 'Next',
            disabled: loading || !stepCompleted,
            loading: loading,
            onClick: goToNextStep,
          },
        ],
        shown: true,
      },
    };

    if (previewComplete) {
      mainPreviewProps.toolbox.rightButtons.unshift({
        content: 'Import',
        disabled: loading,
        loading: loading,
        onClick: () => {
          setYesNoDialogProps({
            showDialog: true,
            title: 'Import Student',
            question:
              'Have you checked the data in the preview and ensured that it is mapped correctly?',
            yesCallback: () =>
              importStudent({
                StudentId: previewedStudentId,
                SchoolCode: previewedStudentSchoolCode,
              }),
            noCallback: () => {},
            cancelCallback: () => {},
          });
        },
      });
    }
    return mainPreviewProps;
  };

  componentDidUpdate(prevProps) {
    const {
      setPreviewImportSuccessful,
      importSuccessful,
      clearPreviewErrors,
      setStepCompleted,
      studentNotFoundError,
      data,
    } = this.props;

    if (
      errorToast(this.props, prevProps, 'previewError') ||
      errorToast(this.props, prevProps, 'importError')
    ) {
      clearPreviewErrors();
    }

    if (!prevProps.studentNotFoundError && studentNotFoundError) {
      createToast(
        toastType.warning,
        'Could Not Find Student With This Student Id and School Code'
      );
      clearPreviewErrors();
    }

    //preview data has been received, set preview complete
    if (!prevProps.data && data) {
      this.setState({ previewComplete: true });
    }

    //step has been reset, data was cleared
    if (prevProps.data && !data) {
      this.setState({ previewComplete: false });
      setStepCompleted(false);
    }

    if (!prevProps.importSuccessful && importSuccessful) {
      createToast(
        toastType.success,
        'Success',
        'Import Complete. Please check the import log for details.'
      );
      setPreviewImportSuccessful(false);
      setStepCompleted(true);
    }
  }

  handleKeyDown = (e) => {
    const { submitForm } = this.props;
    if (e.key === 'Enter') {
      submitForm(AERIES_PREVIEW_FORM_NAME);
    }
  };

  handleSubmit = (formValues) => {
    const { getPreview } = this.props;
    getPreview(formValues);
    this.setState({
      previewedStudentId: formValues[AeriesFieldEnum.StudentId],
      previewedStudentSchoolCode: formValues[AeriesFieldEnum.SchoolCode],
    });
  };

  render() {
    const { data, loading, configurationData } = this.props;
    return (
      <Main {...this.mainProps()}>
        <AeriesPreview
          data={data}
          handleKeyDown={this.handleKeyDown}
          onSubmit={this.handleSubmit}
          loading={loading}
          config={configurationData}
        />
      </Main>
    );
  }
}

const mapDispatchToProps = { ...actions, submitForm, setYesNoDialogProps };

const mapStateToProps = (state) => {
  const preview = selectors.getPreview(state);
  const configuration = selectors.getConfiguration(state);
  return {
    data: preview.data,
    previewError: preview.errors.previewError,
    studentNotFoundError: preview.errors.studentNotFoundError,
    importError: preview.errors.importError,
    loading: preview.loading || preview.importLoading,
    previewSuccessful: preview.previewSuccessful,
    configurationData: configuration.data,
    importSuccessful: preview.importSuccessful,
  };
};

export const AeriesPreviewStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(AeriesPreviewStepContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesPreviewStep/AeriesPreviewStep.js